import { VendorBankDetailsStatuses } from '@urbanx/agx.campaigns.client';
import { AgxBadge } from '@urbanx/agx.ui-components2';
import type { BadgeColor } from '@urbanx/agx.ui-components2';
import dayjs from 'dayjs';

export const formatVendorBankDetails = (vendorBankDetails?: VendorBankDetailsStatuses) => {
  switch (vendorBankDetails) {
    case VendorBankDetailsStatuses.Complete: {
      return (
        <AgxBadge type="colourfill" variant="normal" size="md" text="Complete" colour="green" />
      );
    }
    case VendorBankDetailsStatuses.Outstanding: {
      return (
        <AgxBadge type="colourfill" variant="normal" size="md" text="Outstanding" colour="red" />
      );
    }
    default: {
      return <AgxBadge type="colourfill" variant="normal" size="md" text="N/A" colour="grey" />;
    }
  }
};

export const formatSettlementDateBadge = (date?: Date | string, status?: string) => {
  if (!date || status?.toLowerCase() === 'terminated') return '--';

  const settlementDate = dayjs(date);
  const settlementDateToday = settlementDate.isSame(dayjs(), 'day');

  if (settlementDateToday) {
    return (
      <AgxBadge
        type="highlighted"
        variant="normal"
        size="md"
        highlightText="Today"
        text={`${settlementDate.format('Do MMM')}`}
        colour="yellow"
      />
    );
  }

  return (
    <AgxBadge
      type="colourfill"
      variant="normal"
      size="md"
      text={settlementDate.format('Do MMM')}
      colour="yellow"
    />
  );
};

export const statusBadgeColor = (status?: string): BadgeColor => {
  if (!status) return 'grey';

  switch (status.toLowerCase()) {
    case 'awaiting exchange':
    case 'pending agent exchange':
    case 'pending solicitor exchange':
      return 'blue';
    case 'accepted':
      return 'yellow';
    case 'unconditional':
      return 'teal';
    case 'conditional':
      return 'orange';
    case 'settled':
      return 'green';
    case 'back up':
      return 'purple';
    case 'terminated':
      return 'grey';
    case 'pending compliance':
      return 'purple';
    default:
      return 'grey';
  }
};
